const CartIcon = ({ color }: { color: string }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_18_4595)">
                <path
                    d="M12.126 11.8891C11.1021 11.8891 10.2578 12.7154 10.2578 13.7573C10.2578 14.7813 11.0841 15.6256 12.126 15.6256C13.15 15.6256 13.9943 14.7992 13.9943 13.7573C13.9763 12.7334 13.15 11.8891 12.126 11.8891Z"
                    fill={color}
                />
                <path
                    d="M15.4129 2.97908C15.377 2.97908 15.3231 2.96111 15.2692 2.96111H3.95203L3.77239 1.75754C3.66461 0.967133 2.98199 0.374329 2.17362 0.374329H0.718551C0.323348 0.374329 0 0.697676 0 1.09288C0 1.48808 0.323348 1.81143 0.718551 1.81143H2.17362C2.26343 1.81143 2.33529 1.88329 2.35325 1.9731L3.46701 9.55382C3.61072 10.5059 4.43705 11.2244 5.40709 11.2244H12.88C13.8141 11.2244 14.6225 10.5598 14.8201 9.64363L15.9878 3.80541C16.0596 3.42817 15.8081 3.05093 15.4129 2.97908Z"
                    fill={color}
                />
                <path
                    d="M7.54431 13.6675C7.50838 12.6795 6.68205 11.8891 5.69404 11.8891C4.65214 11.943 3.86173 12.8053 3.89766 13.8292C3.93359 14.8172 4.74196 15.6076 5.72997 15.6076H5.76589C6.78983 15.5537 7.5982 14.6914 7.54431 13.6675Z"
                    fill={color}
                />
            </g>
        </svg>
    );
};

export default CartIcon;
